import {
    jumpToMediaSelector,
    previousMediaSelector,
    nextMediaSelector,
    previousGroupPositionSelector,
    nextGroupPositionSelector,
    jumpToGroupPositionSelector,
    getGroupPosition,
    keepMediaPositionInBoundaries,
    forwardMediaSelector,
    backwardMediaSelector,
    firstMediaSelector,
    lastMediaSelector,
} from '../navigation/selectors'
import {
    getMediaType,
    getMediaAtPosition,
    isMediaLoaded,
} from '../mediaList/selectors'
import {
    fetchMedia,
    fetchGroup,
} from '../mediaList/actions'
import { retrieveAvailableFilters } from '../availableFilters/selectors'
import { initCurrentMedia } from '../currentMedia/actions'
import { initializeContext } from '../visualizer/actions'
import { fetchingMediaBoundaries } from '../fetchingMedia/selectors'
import { unselectCollaborativeIndexationZone } from '../collaborativeIndexations/actions'
import { isNavigationEnabled } from './selectors'

export const INIT_NAVIGATION = 'INIT_NAVIGATION'
export function initNavigation(navigation)
{
    return function initNavigation(dispatch)
    {
        dispatch({ type: INIT_NAVIGATION, navigation })
    }
}

export const PREVIOUS_MEDIA = 'PREVIOUS_MEDIA'
export function previousMedia()
{
    return function previousMedia(dispatch, getState)
    {
        dispatch(moveToMedia(previousMediaSelector, PREVIOUS_MEDIA))
    }
}

export const NEXT_MEDIA = 'NEXT_MEDIA'
export function nextMedia()
{
    return function nextMedia(dispatch, getState)
    {
        dispatch(moveToMedia(nextMediaSelector, NEXT_MEDIA))
    }
}

export const FORWARD_MEDIA = 'FORWARD_MEDIA'
export function forwardMedia()
{
    return function forwardMedia(dispatch, getState)
    {
        dispatch(moveToMedia(forwardMediaSelector, FORWARD_MEDIA))
    }
}

export const BACKWARD_MEDIA = 'BACKWARD_MEDIA'
export function backwardMedia()
{
    return function backwardMedia(dispatch, getState)
    {
        dispatch(moveToMedia(backwardMediaSelector, BACKWARD_MEDIA))
    }
}

export const FIRST_MEDIA = 'FIRST_MEDIA'
export function firstMedia()
{
    return function firstMedia(dispatch, getState)
    {
        dispatch(moveToMedia(firstMediaSelector, FIRST_MEDIA))
    }
}

export const LAST_MEDIA = 'LAST_MEDIA'
export function lastMedia()
{
    return function lastMedia(dispatch, getState)
    {
        dispatch(moveToMedia(lastMediaSelector, LAST_MEDIA))
    }
}

export function moveToMedia(mediaSelector, actionType)
{
    return async function moveToMedia(dispatch, getState)
    {

        if(! isNavigationEnabled(getState()))
        {
            return
        }

        const navigation = mediaSelector(getState())

        await fetchMediaIfNecessary(dispatch, getState(), navigation.media.position)

        const media = getMediaAtPosition(getState(), navigation.media.position)

        dispatch({
            type: actionType,
            navigation,
            filters: availableFilters(getState(), navigation.media.position),
        })

        dispatch(initCurrentMedia(media))
        dispatch(unselectCollaborativeIndexationZone())
    }
}

export const jumpToMediaGroup = (positions, mediaId) => (dispatch, getState) => {

    if(! positions) return

    const { group, media } = positions

    if(group === getGroupPosition(getState()))
    {
        return dispatch(jumpToMedia(media))
    }

    dispatch(initializeContext(mediaId))
}

export const JUMP_TO_MEDIA = 'JUMP_TO_MEDIA'
export function jumpToMedia(position)
{
    return async function jumpToMedia(dispatch, getState)
    {
        const currentState = getState()
        if(! isNavigationEnabled(getState()))
        {
            return
        }

        let newPosition = keepMediaPositionInBoundaries(currentState, position)
        const navigation = jumpToMediaSelector(currentState, newPosition)

        await fetchMediaIfNecessary(dispatch, currentState, navigation.media.position)

        dispatch({
            type: JUMP_TO_MEDIA,
            navigation,
            filters: availableFilters(getState(),navigation.media.position),
        })

        const media = getMediaAtPosition(getState(), navigation.media.position)
        if(media !== undefined)
        {
            dispatch(initCurrentMedia(media))
        }
    }
}

export const PREVIOUS_GROUP = 'PREVIOUS_GROUP'
export function previousGroup()
{
    return function previousGroup(dispatch, getState)
    {
        if(! isNavigationEnabled(getState()))
        {
            return
        }

        dispatch({
            type: PREVIOUS_GROUP,
        })
        dispatch(fetchGroup(
            previousGroupPositionSelector(getState())
        ))
    }
}

export const NEXT_GROUP = 'NEXT_GROUP'
export function nextGroup()
{
    return function  nextGroup(dispatch, getState)
    {
        if(! isNavigationEnabled(getState()))
        {
            return
        }

        dispatch({
            type: NEXT_GROUP,
        })
        dispatch(fetchGroup(
            nextGroupPositionSelector(getState())
        ))
    }
}

export const JUMP_TO_GROUP = 'JUMP_TO_GROUP'
export function jumpToGroup(position)
{
    return function jumpToGroup(dispatch, getState)
    {

        if(! isNavigationEnabled(getState()))
        {
            return
        }

        dispatch({
            type: JUMP_TO_GROUP,
        })
        dispatch(fetchGroup(
            jumpToGroupPositionSelector(getState(), position)
        ))
    }
}

function availableFilters(state, position)
{
    const mediaType = getMediaType(state, position)

    return retrieveAvailableFilters(state, mediaType)
}

async function fetchMediaIfNecessary(dispatch, state, position)
{
    if(! isMediaLoaded(state, position))
    {
        const boundaries = fetchingMediaBoundaries(state, position)
        await dispatch(fetchMedia(boundaries.start, boundaries.end))
    }
}
